import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withInit from 'WithInit';
import { openPanel } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions';
import { getPopupIdsOnPage } from 'Popups/helpers';
import SelfServeBuilderEditor from './SelfServeBuilderEditor';
import {
  enablePopupCreation,
  disablePopupCreation,
  setPagesFromFile,
  loadCustomTemplateData,
  setSampleState,
  setZeroState,
  setIsRecipientPreviewModalVisible,
} from './SelfServeBuilderActions';

export { enablePopupCreation, disablePopupCreation };
export { default as PaginationManager } from './PaginationManager';
export { default as IconButton } from './IconButton';

const mapStateToProps = ({
  SelfServeBuilderReducer,
  popupHandler,
  PopupGroupReducer,
  SelfServePostBuilderSidePanelHandler,
}, ownProps) => ({
  documentUrl: ownProps.documentUrl,
  documentType: ownProps.documentType,
  pages: SelfServeBuilderReducer.pages,
  isScalingEnabled: SelfServeBuilderReducer.isScalingEnabled,
  isLoading: SelfServeBuilderReducer.isLoading,
  isSampleState: SelfServeBuilderReducer.isSampleState,
  isZeroStateModalOpen: SelfServeBuilderReducer.isZeroStateModalOpen,
  popups: popupHandler.popups,
  popupIdsOnPage: getPopupIdsOnPage(popupHandler.popups),
  popupGroups: PopupGroupReducer.popupGroups,
  popupGroupsOnPage: PopupGroupReducer.popupGroupsOnPage,
  isPublic: SelfServeBuilderReducer.isPublic,
  isShared: SelfServeBuilderReducer.isShared,
  publishedAt: SelfServeBuilderReducer.publishedAt,
  sections: SelfServePostBuilderSidePanelHandler.SectionOrganizerReducer.sections,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loadCustomTemplateData,
    openPanel,
    setIsRecipientPreviewModalVisible,
    setPagesFromFile,
    setSampleState,
    setZeroState,
  }, dispatch)
);

export const SelfServeBuilderWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelfServeBuilderEditor);

export default withInit(SelfServeBuilderWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/index.jsx